import { registerQuery, useQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import { getEarlyRequesterResultPromise } from '../utils/getEarlyRequesterResultPromise';
export const USER_SETTINGS_QUERY_NAME = 'cmsUserSettings';
export const UserSettingsQuery = registerQuery({
  fieldName: USER_SETTINGS_QUERY_NAME,
  fetcher: () => {
    return getEarlyRequesterResultPromise({
      name: 'fetch-cms-user-settings',
      retryRequest: () => http.get('cms-user-settings')
    });
  }
});
export const useCmsUserSettings = ({
  skip = false
}) => {
  const {
    data,
    loading,
    error
  } = useQuery(UserSettingsQuery, {
    skip
  });
  return {
    userSettings: (data === null || data === void 0 ? void 0 : data.cmsUserSettings) || {},
    loading,
    error
  };
};